import { NavLink } from 'react-router-dom';
// import './inner-page-navigation.scss';
import { QueryRequestHelper } from '@_common/query-request-helper';
import { getValue } from '@utils/lodash';

export default function TaskNavigation(props: any) {
	const urlSearchParams = new URLSearchParams(window.location.search);
	let compliance_task_ids: any = urlSearchParams.getAll(
		'compliance_task_ids[]'
	);
	let queryRequest = QueryRequestHelper({
		compliance_task_ids: compliance_task_ids,
	});
	return (
		<div className="task-license-subheader">
			<div className="inner-page-navigation-with-back-cta-buttons position-relative">
				<div className="container-fluid  d-flex justify-content-between align-items-center">
					<div className="d-flex">
						<NavLink
							to={`/activities/task/compliance/list/${props.id}?firstDay=${props.firstDay}&lastDay=${props.lastDay}&${queryRequest}`}
							className=""
						>
							<img
								src="/images/back-link.svg"
								className="img-fluid"
								height={24}
								width={24}
							/>
						</NavLink>
						<div className="inner-page-navigation-with-back-cta-button__header">
							<h4 className="inner-page-navigation-with-back-cta-button__header-title"></h4>
						</div>
					</div>
					<ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
						{!props.id && (
							<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
								<NavLink
									to={`/activities/task/compliance/list/detail/${props.id}`}
									className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
								>
									Task Details
								</NavLink>
							</li>
						)}
						{props.id && props.id !== 'undefined' && (
							<>
								<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
									<NavLink
										to={`/activities/task/compliance/list/detail/${props.id}/${props.taskId}/${props.checkpoint_id}/${props.firstDay}/${props.lastDay}/${props.locationId}/${props.functionId}?${queryRequest}`}
										className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
									>
										Task Details
									</NavLink>
								</li>
								<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
									<NavLink
										to={`/activities/task/compliance/list/history/${props.id}/${props.taskId}/${props.checkpoint_id}/${props.firstDay}/${props.lastDay}/${props.locationId}/${props.functionId}?${queryRequest}`}
										className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
									>
										Task History
									</NavLink>
								</li>
								<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
									<NavLink
										to={`/activities/task/compliance/list/comments/${props.id}/${props.taskId}/${props.checkpoint_id}/${props.firstDay}/${props.lastDay}/${props.locationId}/${props.functionId}?${queryRequest}`}
										className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
									>
										Comments
									</NavLink>
								</li>
							</>
						)}
					</ul>
					{getValue(props, `permissions`, []).includes('update') ? (
						<div>
							{/* <button className="ascent-button ascent-button--header-buttons ascent-button--secondary mx-3">
							Edit
						</button> */}
							{props.save ? (
								props.submitLoading ? (
									<button className="ascent-button  ascent-button--header-buttons ascent-button--primary">
										Please wait...
									</button>
								) : (
									<button
										className={`ascent-button  ascent-button--header-buttons ascent-button--${
											!props.isChanged ? 'secondary' : 'primary'
										}`}
										onClick={props.handleSubmit}
										// disabled={props.isChanged}
									>
										Save
									</button>
								)
							) : (
								<button className="ascent-button ascent-button--visibility ascent-button--header-buttons ascent-button--primary">
									Save
								</button>
							)}
						</div>
					) : (
						<button className="ascent-button ascent-button--visibility ascent-button--header-buttons ascent-button--primary">
							Save
						</button>
					)}
				</div>
			</div>
		</div>
	);
}
